/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_All_Done_TitleInputs */

const en_shopping_all_done_title = /** @type {(inputs: Shopping_All_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All in the basket`)
};

const de_shopping_all_done_title = /** @type {(inputs: Shopping_All_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles im Korb`)
};

/**
* | output |
* | --- |
* | "All in the basket" |
*
* @param {Shopping_All_Done_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_all_done_title = /** @type {((inputs?: Shopping_All_Done_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_All_Done_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_all_done_title(inputs)
	return en_shopping_all_done_title(inputs)
});